import { render } from "./MGButton.vue?vue&type=template&id=36d6ce9a&scoped=true"
import script from "./MGButton.vue?vue&type=script&lang=js"
export * from "./MGButton.vue?vue&type=script&lang=js"

import "./MGButton.vue?vue&type=style&index=0&id=36d6ce9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d6ce9a"]])

export default __exports__